import { tv } from 'tailwind-variants';

export const buttonStyles = tv({
  base: 'cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all duration-300 [&_svg]:pointer-events-none [&_svg]:shrink-0 ring-ring/10 dark:ring-ring/20 dark:outline-ring/40 outline-ring/50 focus-visible:ring-4 focus-visible:outline-1 aria-invalid:focus-visible:ring-0',
  variants: {
    variant: {
      primary:
        'bg-primary text-primary-foreground shadow-sm hover:bg-primary/80',
      'primary-dark-one':
        'bg-primary-dark-one text-primary-dark-one-foreground shadow-sm hover:bg-primary-dark-one/80',
      'primary-dark-two':
        'bg-primary-dark-two text-primary-dark-two-foreground shadow-sm hover:bg-primary-dark-two/80',
      destructive:
        'bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90',
      'destructive-dark':
        'bg-destructive-dark text-destructive-dark-foreground shadow-xs hover:bg-destructive-dark/90',
      outline: 'border border-input bg-transparent hover:opacity-70',
      secondary:
        'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
      tertiary:
        'bg-tertiary text-tertiary-foreground shadow-xs hover:bg-tertiary/80',
      ghost: 'hover:bg-primary/10 hover:opacity-70',
      link: 'text-primary underline-offset-4 hover:underline',
      transparent: 'bg-transparent hover:opacity-60',
      neutral: 'bg-zinc-300 text-zinc-500  hover:bg-zinc-200/80',
      google: 'bg-card text-foreground border border-border hover:bg-muted',
    },
    size: {
      default: "h-9 px-4 py-2 [&_svg:not([class*='size'])]:size-6",
      sm: "h-7 px-3 [&_svg:not([class*='size'])]:size-4",
      xs: "h-5 px-1.5 [&_svg:not([class*='size'])]:size-3",
      lg: "h-12 px-6 [&_svg:not([class*='size'])]:size-7",
      xl: "h-14 px-6 [&_svg:not([class*='size'])]:size-8",
      icon: "size-9 [&_svg:not([class*='size'])]:size-6",
    },
    rounded: {
      xs: 'rounded-xs',
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      full: 'rounded-full',
    },
    disabled: {
      true: 'cursor-not-allowed opacity-50 pointer-events-none',
    },
    textTransform: {
      uppercase: 'uppercase',
      none: '',
    },
    float: {
      true: 'shadow-lg fixed z-10',
    },
    floatPosition: {
      'bottom-right': 'bottom-6 right-6',
      'bottom-left': 'bottom-6 left-6',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'default',
    rounded: 'lg',
    textTransform: 'uppercase',
  },
});
